<template>
    <div class="hello">
        <StatusBar/>
        <SurveyList></SurveyList>
    </div>
</template>

<script>
    import StatusBar from './StatusBar.vue'
    import SurveyList from './Survey/SurveyList.vue'

    export default {
        components: {
            StatusBar,
            SurveyList,
        },
        name: 'Dashboard'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }
</style>
